import { graphTypes } from "./GraphTypes";

export const CHANGE_GLOBAL_SETTING = 'change-global-setting';
export const CHANGE_SETTING_FOR_GRAPH_TYPE = 'change-setting-for-graph-type';
export const CHANGE_SELECTED_MED_IDS = 'change-selected-med-ids';

export const graphConfigActions = {
  changeSetting: (key, value) => ({
    type: CHANGE_GLOBAL_SETTING,
    key,
    value,
  }),
  changeSettingForGraphType: (graphType, key, value) => ({
    type: CHANGE_SETTING_FOR_GRAPH_TYPE,
    graphType,
    key,
    value,
  }),
  changeSelectedMedIds: (graphType, patientId, value) => ({
    type: CHANGE_SELECTED_MED_IDS,
    graphType,
    key: 'selectedMedIds',
    patientId,
    value,
  }),
};

export const graphConfigReducer = (
    state = {
      showAlertThresholds: true,
      showGoals: true,
      showTrendlines: true,
      showReminders: true,
      ...graphTypes.reduce((acc, gt) => {
        acc[gt.id] = {
          selectedMetrics: gt.defaultMetrics || gt.metrics,
          selectedMedIds: {},
          metricForThresholds: gt.mostValuableMetric,
        };
        return acc;
      }, {}),
    },
  action,
) => {
  switch (action.type) {
    case CHANGE_GLOBAL_SETTING:
      return {
        ...state,
        [action.key]: action.value,
      };
    case CHANGE_SETTING_FOR_GRAPH_TYPE:
      return {
        ...state,
        [action.graphType]: {
          ...state[action.graphType],
          [action.key]: action.value,
        },
      };
    case CHANGE_SELECTED_MED_IDS:
      return {
        ...state,
        [action.graphType]: {
          ...state[action.graphType],
          selectedMedIds: {
            ...state[action.graphType].selectedMedIds,
            [action.patientId]: action.value,
          },
        },
      };
    default:
      return state;
  }
};